import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionVideo from "hooks/form/blocks/useSectionVideo";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionVideoForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, formHook } = useSectionVideo();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <GridColumn>
                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                label={"Url del video"}
                                value={form.video}
                                setValue={setValue}
                                path={"video"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        {blockId === BlockEnum.SectionVideoFull && (
                            <GridItem className={"col-xs-12-6"}>
                                <InputText
                                    label={"Url del video per il mobile"}
                                    value={form.video_mobile}
                                    setValue={setValue}
                                    path={"video_mobile"}
                                    checkErrorVisibility={checkErrorVisibility}
                                />
                            </GridItem>
                        )}
                    </GridRow>
                </GridColumn>
            )}
        </>
    );
}

export default SectionVideoForm;
